import {
    type ApiUser,
    EnumAccessState,
    EnumPartnershipConsent,
    getBadgeVariantByAccessState,
    getEnumAccessStateLabel,
} from '@Model';
import { type BadgeProps } from '@synqo/frontend-component-library';

/**
 * The badges that describe where a user stands.
 */
// @ai-generated 2026-09-10T08:36:02+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
export function getUserStateBadges(user: ApiUser): BadgeProps[] {
    const isBlocked = user.access_state === EnumAccessState.Locked;
    const blockedBadges: BadgeProps[] = isBlocked
        ? [
              {
                  children: getEnumAccessStateLabel(EnumAccessState.Locked),
                  variant: getBadgeVariantByAccessState(EnumAccessState.Locked),
              },
          ]
        : [];

    if (user.partnership_consent === EnumPartnershipConsent.Rejected) {
        return [...blockedBadges, { children: 'Einladung abgelehnt', variant: 'danger' }];
    }
    if (!user.is_activated) {
        return [...blockedBadges, { children: 'Noch nicht aktiviert', variant: 'info' }];
    }
    if (user.partnership_consent !== EnumPartnershipConsent.Accepted) {
        return [...blockedBadges, { children: 'Bestätigung ausstehend', variant: 'accent' }];
    }

    return [
        {
            children: getEnumAccessStateLabel(user.access_state),
            variant: getBadgeVariantByAccessState(user.access_state),
        },
    ];
}
